import TermLengths from './TermLengths';
import AboutData from './AboutData';
import ProductSpecificationsData from './ProductSpecificationsData';
import HowToPurchaseData from './HowToPurchaseData';
import HowDoesItWork from './HowDoesItWorkData';
import WhoIsThisProductFor from './WhoIsThisProductData';
import HowIsItUsed from './HowIsItUsedData';

export default function UniversalLifeData() {
  const minAge = 30;
  const maxAge = 75;
  const minCoverageAmount = 50000;
  const maxCoverageAmount = 500000;

  return {
    name: 'Asset-based Long-term Care',
    subtitle: '',
    specs: {
      age: { min: minAge, max: maxAge },
      coverageAmount: { min: minCoverageAmount, max: maxCoverageAmount },
    },
    hyperlinks: [
      {
        title: 'ABOUT',
        link: 'about'

      },
      {
        title: 'HOW DOES IT WORK',
        link: 'howDoesItWork',
      },
      {
        title: 'WHO IS THIS PRODUCT FOR',
        link: 'whoIsThisProductFor',
      },
      {
        title: 'HOW TO PURCHASE',
        link: 'howToPurchase',
      }
    ],
    about: AboutData(),
    productSpecifications: ProductSpecificationsData(minAge, maxAge, minCoverageAmount, maxCoverageAmount, TermLengths()),
    howToPurchase: HowToPurchaseData(),
    howDoesItWorkData: HowDoesItWork(),
    WhoIsThisProductData: WhoIsThisProductFor(),
    HowIsItUsedData: HowIsItUsed()
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/data/products/asset-based-ltc/AssetBasedHybridLtcData.js